import React from 'react';
import Transformations from '../components/Transformations';
import Testimonials from '../components/Testimonials';

const ResultsPage = () => {
  return (
    <>
      <Transformations />
      <Testimonials />
    </>
  );
};

export default ResultsPage;
